import Component from './component';

Component.defaultProps = {
    onSuccess: null,
};
export default Component;
